export const CHECKOUT_URL = 'https://educazione-fisica-pronta.impultienda.ar/checkout'

export const OFFER_ANCHOR = '#offer'

export const CTA_LABEL = 'OTTIENI EDUCAZIONE FISICA PRONTA™ ORA'
